import i18nFactory from '@yandex-int/i18n';

import { GdFreelancerSkillOfferDuration } from '../../typings/graphql-grid';

import * as keyset from './FreelancerServiceOfferDuration.i18n';

const i18n = i18nFactory(keyset);

/**
 * Возвращает перевод типа длительности сотрудничества
 */
export function translateFreelancerServiceDuration(
    duration: GdFreelancerSkillOfferDuration
): string {
    switch (duration) {
        case GdFreelancerSkillOfferDuration.FROM_1_TO_3_DAYS:
            return i18n('FROM_1_TO_3_DAYS');
        case GdFreelancerSkillOfferDuration.FROM_3_TO_7_DAYS:
            return i18n('FROM_3_TO_7_DAYS');
        case GdFreelancerSkillOfferDuration.FROM_7_TO_14_DAYS:
            return i18n('FROM_7_TO_14_DAYS');
        case GdFreelancerSkillOfferDuration.FROM_14_TO_28_DAYS:
            return i18n('FROM_14_TO_28_DAYS');
        case GdFreelancerSkillOfferDuration.MONTHLY:
            return i18n('MONTHLY');
        case GdFreelancerSkillOfferDuration.FROM_1_TO_3_MONTHS:
            return i18n('FROM_1_TO_3_MONTHS');
        default:
            return i18n('MORE_THAN_3_MONTHS');
    }
}
